export function update_calendar_data(data) {
    return {
        type: 'UPDATE_CALENDAR_DATA',
        data
    }
}

export function update_phone_mts_data(data) {
    return {
        type: 'UPDATE_PHONE_MTS_DATA',
        data
    }
}

export function update_phone_a1_data(data) {
    return {
        type: 'UPDATE_PHONE_A1_DATA',
        data
    }
}

export function update_contact_data(text) {
    return {
        type: 'UPDATE_CONTACT_DATA',
        text
    }
}

export function update_work_data(text) {
    return {
        type: 'UPDATE_WORK_DATA',
        text
    }
}